import classnames from 'classnames'

export type ButtonProps = {
  primary?: boolean
  variant?: 'default' | 'outline' | 'secondary' | 'ghost' | 'link'
  size?: 'small' | 'medium' | 'large'
  children?: React.ReactNode
} & React.ButtonHTMLAttributes<HTMLButtonElement>

const variantClassMap: Record<NonNullable<ButtonProps['variant']>, string> = {
  default: 'border border-primary bg-primary text-black hover:opacity-90',
  outline: 'border border-zinc-300 bg-white text-zinc-900 hover:bg-zinc-50',
  secondary:
    'border border-zinc-200 bg-zinc-100 text-zinc-900 hover:bg-zinc-200',
  ghost:
    'border border-transparent bg-transparent text-zinc-900 hover:bg-zinc-100',
  link: 'border border-transparent bg-transparent text-primary underline-offset-4 hover:underline'
}

const sizeClassMap: Record<NonNullable<ButtonProps['size']>, string> = {
  small: 'h-8 px-3 text-sm',
  medium: 'h-10 px-4 text-sm',
  large: 'h-11 px-6 text-base'
}

export default function Button({
  primary = false,
  variant = 'outline',
  size = 'medium',
  className,
  children,
  type,
  ...props
}: ButtonProps) {
  const resolvedVariant = primary ? 'default' : variant

  return (
    <button
      type={type ?? 'button'}
      className={classnames(
        'inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md font-medium transition-colors',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40',
        'disabled:pointer-events-none disabled:opacity-50',
        sizeClassMap[size],
        variantClassMap[resolvedVariant],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
